import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import removeAllErrorMsg from "../../../../../components/funcRemoveAllErros"
import { FormEvent, useState } from "react"
import { ApiEndpoints, reqPostNew } from "../../../../../config/apiClient"
import dayjs from "dayjs"

export default function ModalCancelarNfse({ show, handleClose, handleCancelarEvento, handleCancelar, nota }: iProps) {
    const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false)

    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form: any = event.target
        let formValidado = true

        let dados = {
            evento_cod: "101101",
            evento_nome: "Evento Cancelamento de NFS-e",
            chave_nfs: nota.id_chave,
            evento_descricao: "Cancelamento de NFS-e",
            evento_motivo_cod: Number(form.motivo_cod.value),
            evento_motivo_descricao: form.justificativa.value,
        }

        if (dados.evento_motivo_cod === 0) {
            form.motivo_cod.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.evento_motivo_descricao === "" || dados.evento_motivo_descricao.length < 10) {
            form.justificativa.nextElementSibling.style.display = "block"
            formValidado = false
        }

        console.log(dados)
        if (!formValidado) {
            return
        }

        cancelar(dados)
    }

    async function cancelar(dados: any) {
        if (!window.confirm("Tem certeza que deseja CANCELAR?")) {
            return
        }

        setIsFormDisabled(true)
        const api = await reqPostNew(ApiEndpoints.nfseEnviarEvento, dados)
        setIsFormDisabled(false)
        handleCancelarEvento(api)
    }

    async function cancelarStatus() {
        if (!window.confirm("NFS-e foi cancelada no site do governo?")) {
            window.alert("CANCELAR NOTA NO SITE DO GOVERNO, LINK ABAIXO!")            
            return
        }

        if (!window.confirm("Tem certeza que deseja CANCELAR?")) {
            return
        }

        setIsFormDisabled(true)
        const dados = {
            id_nota: nota.id,
        }
        const api = await reqPostNew(ApiEndpoints.nfseCancelar, dados)
        handleCancelar(api)
        setIsFormDisabled(false)
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            id="modal_nf_cancelar"
        >
            <Modal.Header closeButton>
                <Modal.Title>Cancelar NFS-e</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formEnviarEvento`} onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Chave NFS-e:</Form.Label>
                                <Form.Control type="text" name="chave_nfse" id="chave_nfse" disabled={true} defaultValue={nota.id_chave} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Cliente:</Form.Label>
                                <Form.Control type="text" name="cliente_nfse" id="cliente_nfse" disabled={true} defaultValue={`${nota.id_cliente.cnpj} - ${nota.id_cliente.nome}`} />
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>Emitido em:</Form.Label>
                                <Form.Control type="text" name="data_emissao_nfse" id="data_emissao_nfse" disabled={true} defaultValue={`${dayjs(nota.data_emissao).format("DD/MM/YYYY HH:mm")}`} />
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>Valor:</Form.Label>
                                <Form.Control type="text" name="valor_nfse" id="valor_nfse" disabled={true} defaultValue={`${nota.valor_servicos}`} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col className="col-12">
                            <Form.Label>Motivo:</Form.Label>
                            <Form.Select name="motivo_cod" id="motivo_cod" disabled={isFormDisabled} aria-label="Selecione a opção">
                                <option value="0">Não informado</option>
                                <option value="1">Erro na emissão</option>
                                <option value="2">Serviço não prestado</option>
                                <option value="9">Outros</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe o motivo do cancelamento!
                            </Form.Control.Feedback>
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Justificativa:</Form.Label>
                                <Form.Control as="textarea" rows={8} maxLength={1000} name='justificativa' id='justificativa' autoComplete='off' disabled={isFormDisabled} />
                                <Form.Control.Feedback type="invalid">
                                    Preencha a justificativa do cancelamento!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br />
                    <Button type="submit" variant="danger" disabled={isFormDisabled}>Cancelar NFS-e</Button>
                </Form>
                <br></br>
                <p style={{marginBottom: "5px", fontWeight: "bold"}}>CASO O FORMULÁRIO ACIMA NÃO FUNCIONAR!</p>
                <p style={{marginBottom: "5px"}}><b>1.</b> Acesse o site do governo, <a href="https://www.nfse.gov.br/EmissorNacional/Notas/Emitidas" target="_blank" rel="noreferrer">clique aqui</a>.</p>
                <p style={{marginBottom: "5px"}}><b>2.</b> Selecione o certificado da empresa: <b>{nota.id_empresa.nome}</b></p>
                <p style={{marginBottom: "5px"}}><b>3.</b> Encontre a NFS-e e selecione a opção para cancelar no menu oculto.</p>
                <p style={{marginBottom: "5px"}}><b>4.</b> Após cancelado, clique no botão abaixo para atualizar o status da nota.</p>
                <br></br>
                <Button variant="secondary" disabled={isFormDisabled} onClick={() => { cancelarStatus() }} size="sm" >Atualizar Status NFS-e para cancelado</Button>
                <br></br>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}

interface iProps {
    show: boolean
    handleClose: any
    handleCancelarEvento: any
    handleCancelar: any
    nota: any
}
